import { StyleSheet, View } from 'react-native';
import Animated from 'react-native-reanimated';
import theme from 'shared/styles/theme';

const DOT_SIZE = 8;
const ACTIVE_DOT_WIDTH = 16;
const DOT_GAP = 10;

// Exception to the GPU-only animation rule: the slide indicator spec (Figma node
// 2930-25449) morphs the active pill's width between dots, and scaling a rounded
// dot with transforms distorts its ends.
const DOT_TRANSITION = {
  transitionProperty: ['width', 'backgroundColor'],
  transitionDuration: '400ms',
  transitionTimingFunction: 'ease-in-out',
};

interface PageIndicatorProps {
  pageCount: number;
  activePage: number;
  accessibilityLabel: string;
}

const PageIndicator = ({
  pageCount,
  activePage,
  accessibilityLabel,
}: PageIndicatorProps) => {
  const pages = Array.from({ length: pageCount }, (_, page) => page);

  return (
    <View
      accessible
      accessibilityLabel={accessibilityLabel}
      style={styles.container}
    >
      {pages.map((page) => (
        <Animated.View
          key={page}
          style={[
            styles.dot,
            page === activePage ? styles.activeDot : null,
            DOT_TRANSITION,
          ]}
        />
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  activeDot: {
    backgroundColor: theme.color.interactive.primary,
    width: ACTIVE_DOT_WIDTH,
  },
  container: {
    flexDirection: 'row',
    gap: DOT_GAP,
  },
  dot: {
    backgroundColor: theme.color.background.secondary,
    borderRadius: DOT_SIZE,
    height: DOT_SIZE,
    width: DOT_SIZE,
  },
});

export default PageIndicator;
